import { ColorSelectorUtil, SelectedColor } from "@mcleod/common";
import { AutogenLayoutProfileColor } from "./autogen/AutogenLayoutProfileColor";
import { DataSource, DataSourceExecutionEvent } from "@mcleod/components";

export class ProfileColor extends AutogenLayoutProfileColor {
    private _profileDataSource: DataSource;
    private afterExecute = (event: DataSourceExecutionEvent) => this.panelColorDisplay.backgroundColor = this.profileDataSource?.activeRow?.get("profile_color");

    get profileDataSource() {
        return this._profileDataSource;
    }

    set profileDataSource(value: DataSource) {
        if (this._profileDataSource) {
            this._profileDataSource.removeAfterExecutionListener(this.afterExecute);
        }
        this._profileDataSource = value;
        this._profileDataSource.addAfterExecutionListener(this.afterExecute);
    }

    buttonClearColorOnClick() {
        this.syncPlanningColor({});
    }

    async buttonColorPickerOnClick() {
        const result = await ColorSelectorUtil.promptForHexColor();
        if (result?.hexColor) {
            this.syncPlanningColor(result);
        }
    }

    private syncPlanningColor(result: SelectedColor = {}) {
        const { colorName, hexColor } = result;
        this.profileDataSource.activeRow.set("profile_color", hexColor ?? null);
        this.panelColorDisplay.backgroundColor = colorName;
        this.panelColorDisplay.tooltip = hexColor;
    }
}
